import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { CryptoPayment, NewCryptoPaymentDto } from './crypto-payment.types';

export interface CryptoPaymentConfig {
  enabled: boolean;
  minAmount: number;
  maxAmount: number;
  // Mínimo específico para TRC20 (Tron). El backend lo devuelve igual al
  // minAmount general si no hay una key propia configurada.
  trc20MinAmount: number;
  feePercent: number;
  ttlMinutes: number;
}

@Injectable({ providedIn: 'root' })
export class CryptoPaymentService extends ApiService {
  createPayment(dto: NewCryptoPaymentDto) {
    return this.post<CryptoPayment>('v1/crypto-payment/new', { body: dto });
  }

  getStatus(id: string) {
    return this.get<CryptoPayment>(`v1/crypto-payment/${id}/status`);
  }

  // Recupera un pago por su uuid público (el de la URL). El backend valida que
  // el customer autenticado sea el dueño; si no, devuelve 404.
  getByUuid(uuid: string) {
    return this.get<CryptoPayment>(`v1/crypto-payment/by-uuid/${uuid}`);
  }

  cancel(id: string) {
    return this.post<CryptoPayment>(`v1/crypto-payment/${id}/cancel`, { body: {} });
  }

  getConfig() {
    return this.get<CryptoPaymentConfig>('v1/crypto-payment/config');
  }
}
